import { IconSearch, IconX } from '@tabler/icons-react';
import React from 'react';

const SearchComponent = ({ placeholder, onInputChange, onSearch, onClear, inputValue, inputId = 'table-search' }) => {
    return (
        <>
            <form onSubmit={(e) => { e.preventDefault(); onSearch() }} className='min-w-[200px] max-w-[400px] w-full flex border-2 rounded-full gap-2 px-3 py-1.5 items-center' >
                <IconSearch size={20} />
                <input type='text' placeholder={placeholder || 'Search Here...'} id={inputId} onChange={(e) => onInputChange && onInputChange(e)} className='!outline-none w-full p-1 text-sm bg-transparent focus:outline-none focus:border-none' />
                {inputValue && <div className='cursor-pointer' onClick={() => onClear()} >
                    <IconX size={18} />
                </div>}
            </form>
        </>
    )
}

export default SearchComponent